import { Controller } from 'stimulus';

export default class ColorPickerComponentController extends Controller {
  static targets = ['colorInput', 'hexInput', 'swatch', 'resetBtn'];
  static values = { defaultL: Number, defaultC: Number, defaultH: Number, allDefaults: Object };

  connect() {
    this._onThemeChange = this.onThemeChange.bind(this);
    this.element.closest('form')?.addEventListener('change', this._onThemeChange);
  }

  disconnect() {
    this.element.closest('form')?.removeEventListener('change', this._onThemeChange);
  }

  onPickerChange(event) {
    const hex = event.target.value;
    this.hexInputTarget.value = hex.toUpperCase();
    this.swatchTarget.style.background = hex;
    this.resetBtnTarget.classList.remove('hidden');
  }

  onHexChange(event) {
    const raw = event.target.value.trim();
    const hex = raw.startsWith('#') ? raw : `#${raw}`;
    if (/^#[0-9a-f]{6}$/i.test(hex)) {
      this.colorInputTarget.value = hex;
      this.swatchTarget.style.background = hex;
      this.resetBtnTarget.classList.remove('hidden');
    }
  }

  reset() {
    const selectedTheme = this.element.closest('form')?.querySelector('[data-theme-name-input]:checked')?.value;
    const hex = (selectedTheme && this.allDefaultsValue[selectedTheme]) || this.hexInputTarget.placeholder;
    this.hexInputTarget.value = '';
    this.hexInputTarget.placeholder = hex;
    this.swatchTarget.style.background = hex;
    this.colorInputTarget.value = hex;
    this.resetBtnTarget.classList.add('hidden');
  }

  onThemeChange(event) {
    if (!event.target.hasAttribute('data-theme-name-input')) return;
    if (this.hasOverride) return;

    const hex = this.allDefaultsValue[event.target.value];
    if (!hex) return;

    this.swatchTarget.style.background = hex;
    this.colorInputTarget.value = hex;
    this.hexInputTarget.placeholder = hex;
  }

  get hasOverride() {
    return this.hexInputTarget.value.trim() !== '';
  }
}
